export async function registerServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) return

  try {
    await navigator.serviceWorker.register('/service-worker.js')
  } catch (error) {
    console.error('[SW] Registration failed:', error)
  }
}

export async function clearServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) return

  const registrations = await navigator.serviceWorker.getRegistrations()
  for (const registration of registrations) {
    registration.unregister()
  }
}
